'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _formLabel = require('../formLabel');

var _textarea = require('../textarea');

require('./textarea-group.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a value is valid to be displayed inside an input.
 * @param {string} value The value to check.
 * @returns {boolean} True if the string provided is valid, false otherwise.
 */
var inputValueIsValid = function inputValueIsValid(value) {
    return value !== '' && value !== undefined && value !== null;
};

/**
 * WH Text Area Group Component
 * @param {Event} event onChange event handler
 * @returns {ReactElement} The react component to the input group
 * @constructor
 */

// css

// components

var TextareaGroup = function (_Component) {
    (0, _inherits3.default)(TextareaGroup, _Component);

    function TextareaGroup(props) {
        (0, _classCallCheck3.default)(this, TextareaGroup);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TextareaGroup.__proto__ || (0, _getPrototypeOf2.default)(TextareaGroup)).call(this, props));

        _this.handleOnFocus = function () {
            var _this$props$onFocus = _this.props.onFocus,
                onFocus = _this$props$onFocus === undefined ? function () {} : _this$props$onFocus;

            _this.setState({
                isFocused: true
            });

            onFocus();
        };

        _this.handleOnBlur = function () {
            var _this$props$onBlur = _this.props.onBlur,
                onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

            _this.setState({
                isFocused: false
            });

            onBlur();
        };

        _this.handleOnChange = function (event) {
            var _this$props$onChange = _this.props.onChange,
                onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


            if (event.target && event.target.value) {
                _this.setState({
                    hasValue: inputValueIsValid(event.target.value)
                });
            }

            onChange();
        };

        _this.state = {
            isFocused: false,
            hasValue: false
        };
        return _this;
    }

    (0, _createClass3.default)(TextareaGroup, [{
        key: 'renderHintText',
        value: function renderHintText() {
            var hintText = this.props.hintText;


            var hintClassName = (0, _classnames2.default)({
                'sb-textarea-hint': true,
                'sb-textarea-hint--show': this.state.isFocused
            });

            if (hintText) {
                return (0, _jsx3.default)('p', {
                    className: hintClassName
                }, void 0, hintText);
            }

            return null;
        }
    }, {
        key: 'renderErrorText',
        value: function renderErrorText() {
            var errorText = this.props.errorText;


            if (errorText) {
                return (0, _jsx3.default)('p', {
                    className: 'sb-textarea-error'
                }, void 0, errorText);
            }

            return null;
        }
    }, {
        key: 'renderFormLabel',
        value: function renderFormLabel() {
            var _props = this.props,
                _props$id = _props.id,
                id = _props$id === undefined ? '' : _props$id,
                label = _props.label;


            if (label) {
                return (0, _jsx3.default)(_formLabel.FormLabel, {
                    htmlFor: id
                }, void 0, label);
            }

            return null;
        }
    }, {
        key: 'renderTextArea',
        value: function renderTextArea() {
            var _props2 = this.props,
                value = _props2.value,
                textareaClassName = _props2.textareaClassName;


            return _react2.default.createElement(
                _textarea.Textarea,
                (0, _extends3.default)({}, this.props, {
                    className: textareaClassName,
                    onFocus: this.handleOnFocus,
                    onChange: this.handleOnChange,
                    onBlur: this.handleOnBlur
                }),
                value
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                _props3$className = _props3.className,
                className = _props3$className === undefined ? '' : _props3$className,
                _props3$isDisabled = _props3.isDisabled,
                isDisabled = _props3$isDisabled === undefined ? false : _props3$isDisabled,
                _props3$isValid = _props3.isValid,
                isValid = _props3$isValid === undefined ? false : _props3$isValid,
                _props3$hasErrors = _props3.hasErrors,
                hasErrors = _props3$hasErrors === undefined ? false : _props3$hasErrors;


            var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
                'sb-textarea-group': true,
                'sb-textarea-group--success': isValid,
                'sb-textarea-group--error': hasErrors,
                'sb-textarea-group--focus': this.state.isFocused,
                'sb-textarea-group--hasValue': this.state.hasValue,
                'sb-textarea-group--disabled': isDisabled
            }, '' + className, className));

            return (0, _jsx3.default)('div', {
                className: classNames
            }, void 0, this.renderFormLabel(), this.renderTextArea(this.props), this.renderHintText(), this.renderErrorText());
        }
    }]);
    return TextareaGroup;
}(_react.Component);

exports.default = TextareaGroup;
//# sourceMappingURL=TextareaGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/textareaGroup/TextareaGroup.js
// module id = 618
// module chunks = 0